/*
__Seed builder__
  AUTO_GENERATED (Read only)
  Helper component
*/

import React from "react";
import { Route as ReactRouterRoute } from "react-router-dom";

const Route = (props) => {
  return <ReactRouterRoute {...props} />;
};
  
export default Route;